import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

export default function Layout({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Fermer le drawer automatiquement au passage desktop (lg: = 1024px)
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia('(min-width: 1024px)');
    const onChange = (e) => { if (e.matches) setDrawerOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  // Bloquer scroll body quand drawer ouvert
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = drawerOpen ? 'hidden' : prev;
    return () => { document.body.style.overflow = prev; };
  }, [drawerOpen]);

  return (
    <div className="min-h-screen" style={{ background: '#0F0F1A' }}>
      <Header drawerOpen={drawerOpen} onToggleDrawer={() => setDrawerOpen(o => !o)} />
      <div className="flex pt-[57px] overflow-x-hidden">
        <Sidebar drawerOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
        <main data-testid="main-content" className="flex-1 min-w-0 p-4 lg:p-6 lg:ml-60 min-h-[calc(100vh-57px)]">
          {children}
        </main>
      </div>
    </div>
  );
}
